/**
 * Get all field paths from a nested object in dot notation
 * Example: { a: { b: 1 } } => ["a", "a.b"]
 */
export function getFieldPaths(obj: unknown, prefix = ""): string[] {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return [];
  }

  const paths: string[] = [];

  Object.keys(obj).forEach((key) => {
    const path = prefix ? `${prefix}.${key}` : key;
    paths.push(path);

    const nestedPaths = getFieldPaths(
      (obj as Record<string, unknown>)[key],
      path
    );
    paths.push(...nestedPaths);
  });

  return paths;
}
